import { SVGProps } from 'react';

const DolarIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="201"
      height="200"
      viewBox="0 0 201 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_228_3925)">
        <mask
          id="mask0_228_3925"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="201"
          height="200"
        >
          <path d="M200.5 0H0.5V200H200.5V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_228_3925)">
          <path
            d="M192.5 48.5996H23.6001C19.1818 48.5996 15.6001 52.1813 15.6001 56.5996V159.3C15.6001 163.718 19.1818 167.3 23.6001 167.3H192.5C196.918 167.3 200.5 163.718 200.5 159.3V56.5996C200.5 52.1813 196.918 48.5996 192.5 48.5996Z"
            fill="#26AA68"
          />
          <path
            d="M177.4 32.7998H8.5C4.08172 32.7998 0.5 36.3815 0.5 40.7998V143.5C0.5 147.918 4.08173 151.5 8.5 151.5H177.4C181.818 151.5 185.4 147.918 185.4 143.5V40.7998C185.4 36.3815 181.818 32.7998 177.4 32.7998Z"
            fill="#B8F0B7"
          />
          <path
            d="M158.8 139.5C158.8 139.555 158.755 139.6 158.7 139.6H29.1999C28.0953 139.6 27.2141 138.699 27.0678 137.604C26.1865 131.007 20.9923 125.813 14.3951 124.932C13.3002 124.785 12.3999 123.904 12.3999 122.8V61.3996C12.3999 60.295 13.3002 59.4138 14.3951 59.2675C20.9923 58.3862 26.1865 53.192 27.0678 46.5948C27.2141 45.4999 28.0953 44.5996 29.1999 44.5996H156.8C157.904 44.5996 158.786 45.4999 158.932 46.5948C159.813 53.192 165.008 58.3862 171.605 59.2675C172.7 59.4138 173.6 60.295 173.6 61.3996V122.7C173.6 123.804 172.7 124.685 171.605 124.832C164.355 125.8 158.8 131.977 158.8 139.5Z"
            fill="#26AA68"
          />
          <path
            d="M93 126.6C112.054 126.6 127.5 111.153 127.5 92.0996C127.5 73.0458 112.054 57.5996 93 57.5996C73.9462 57.5996 58.5 73.0458 58.5 92.0996C58.5 111.153 73.9462 126.6 93 126.6Z"
            fill="#DCFFDB"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_228_3925">
          <rect
            width="200"
            height="200"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DolarIcon;
